import AgentImage from '@lib/core/src/assets/jamie.png';
import palette from '@lib/core/src/theme/palette';
import { Avatar, Tooltip } from '@mui/material';

import { Container, Title, Bubble, AvatarAndTitle, TooltipBox } from './AgentStyle';

interface AgentWrapperProps {
  title: string;
  titleUnderlined: string;
  bubbleText: string;
  children?: React.ReactNode;
  emailBodyHtml?: string;
}

const AgentWrapper = ({
  title,
  titleUnderlined,
  bubbleText,
  children,
  emailBodyHtml
}: AgentWrapperProps) => (
  <Container>
    <AvatarAndTitle>
      <Avatar src={AgentImage} />
      <Title>
        <Tooltip
          arrow
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: 400,
                backgroundColor: palette.white,
                borderRadius: '8px',
                padding: '10px',
                boxShadow:
                  '0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14)'
              }
            },
            arrow: {
              sx: {
                color: palette.white
              }
            }
          }}
          title={<TooltipBox dangerouslySetInnerHTML={{ __html: emailBodyHtml || '' }} />}
        >
          <div>
            {title}
            <u>{titleUnderlined}</u>
          </div>
        </Tooltip>
      </Title>
    </AvatarAndTitle>

    <Bubble>{bubbleText}</Bubble>
    {children}
  </Container>
);

export default AgentWrapper;
